export default "__VITE_ASSET__NBgTc9pz__"